/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import type { SeasonDto } from "$src/core/models/dto";
import CustomPlatform from "$src/core/utils/platform/platform";

export type EpisodeBrowserProps = { seasons: SeasonDto[] };

export default CustomPlatform.select<() => React.FC<EpisodeBrowserProps>>({
  tv: () => require("./EpisodeBrowser.tv").default,
  default: () => require("./EpisodeBrowser").default,
})();
